import {useRouter} from 'next/router';
import {getLocaleContent} from '@helper/locale-content.js';
import BreadcrumbNav from '../common/BreadcrumbNav/index.js';
import {HomeOutlined} from '@ant-design/icons';

function MedialFacilityNav({medicalFacility}) {
    const {locale} = useRouter();
    const facility = Array.isArray(medicalFacility) ? medicalFacility[0] : medicalFacility;

    const facilityName = facility?.business_name || getLocaleContent(locale, 'page.medical-facility.default-name');

    const breadcrumbItems = [
        {label: '', href: '/', icon: <HomeOutlined />},
        {
            label: getLocaleContent(locale, 'page.medical-facility.breadcrumb-title'),
            href: '/co-so-y-te',
            color: '#006940',
            uppercase: false,
        },
    ];

    if (medicalFacility) {
        breadcrumbItems.push({label: facilityName, href: '#', uppercase: false});
    }

    return (
        <div>
            <BreadcrumbNav items={breadcrumbItems} />
        </div>
    );
}

export default MedialFacilityNav;
